import React from "react";

const socialLinks = [
  {
    name: "Facebook",
    href: "https://www.facebook.com/investwithcertainty/",
    svg: (
      <svg
        className="w-5 h-5"
        fill="currentColor"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path d="M22 12a10 10 0 1 0-11.6 9.9v-7h-2v-3h2v-2.3c0-2 1.2-3.2 3-3.2.9 0 1.8.2 1.8.2v2h-1c-1 0-1.3.6-1.3 1.2V12h2.2l-.4 3h-1.8v7A10 10 0 0 0 22 12Z" />
      </svg>
    ),
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/investwithcertainty/?hl=en",
    svg: (
      <svg
        className="w-5 h-5"
        fill="currentColor"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path d="M7 2C4.2 2 2 4.2 2 7v10c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5V7c0-2.8-2.2-5-5-5H7Zm0 2h10c1.7 0 3 1.3 3 3v10c0 1.7-1.3 3-3 3H7c-1.7 0-3-1.3-3-3V7c0-1.7 1.3-3 3-3Zm10.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm0 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z" />
      </svg>
    ),
  },
  {
    name: "Google Reviews",
    href: "https://www.google.com/search?sca_esv=36bf81729798846f&sxsrf=AHTn8zrAoPX8lIDHUTFFLjasw9CCsTTnNg:1747625474915&si=APYL9bs7Hg2KMLB-4tSoTdxuOx8BdRvHbByC_AuVpNyh0x2KzfojZECQ2OOrWX2Gg6yo_ygb_qeLPYljJ35k6Naq7wtApb_lwUqT7_iz0S9snLncE9h3NoqyzDCGvXsXGNM8SJ23T5a2j95XG1wjdkpaULxy6N8_BA%3D%3D&q=Invest+With+Certainty+Reviews&sa=X&ved=2ahUKEwj_14edzK6NAxVV3DgGHVN7MmgQ0bkNegQIIxAE&biw=1512&bih=945&dpr=2",
    svg: (
      <svg
        className="w-5 h-5"
        viewBox="0 0 48 48"
        fill="currentColor"
        aria-hidden="true"
      >
        <path
          fill="#4285F4"
          d="M43.6 20.5H42V20H24v8h11.3C33.3 32.3 29.2 35 24 35c-6.1 0-11-4.9-11-11s4.9-11 11-11c2.9 0 5.5 1.1 7.5 2.9l6-6C33.7 6.4 29.1 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.2-.1-2.1-.4-3.5z"
        />
        <path
          fill="#34A853"
          d="M6.3 14.7l6.6 4.8C14.5 15.5 18.9 13 24 13c2.9 0 5.5 1.1 7.5 2.9l6-6C33.7 6.4 29.1 4 24 4c-6.9 0-12.8 3.1-16.7 8.1z"
        />
        <path
          fill="#FBBC05"
          d="M24 44c5 0 9.5-1.8 13-4.8l-6-4.9c-2.1 1.6-4.8 2.7-7 2.7-5.1 0-9.3-3.4-10.8-8.1l-6.5 5c3.7 7.1 11 11.1 17.3 11.1z"
        />
        <path
          fill="#EA4335"
          d="M43.6 20.5H42V20H24v8h11.3c-1.1 3.2-3.7 5.4-7.3 5.4-2.2 0-4.9-1.1-7-2.7l-6.5 5c3.2 4.5 8.4 7.3 14.5 7.3 8.2 0 15-5.7 17-13.4.3-1.4.5-2.5.5-4.1 0-.8-.1-1.7-.2-2.5z"
        />
      </svg>
    ),
  },
  {
    name: "TikTok",
    href: "https://www.tiktok.com/@investwithcertainty",
    svg: (
      <svg
        className="w-5 h-5"
        viewBox="0 0 48 48"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M33.2 10.4c1.9 2.3 4.8 3.8 8 3.9v6.7a15.4 15.4 0 0 1-9.1-2.9v12.5a10.4 10.4 0 1 1-10.4-10.4c.6 0 1.3.1 1.9.3v6.9a3.6 3.6 0 1 0 2.6 3.4V4.4h6.9c0 2.2.7 4.4 2.1 6z" />
      </svg>
    ),
  },
];

const ReviewsSection = () => {
  return (
    <div className="w-full px-6 py-10 mt-10 bg-white text-black">
      <h2 className="text-center text-2xl md:text-4xl font-bold mb-6">
        WHAT OUR USERS SAY
      </h2>

      <div className="flex flex-wrap justify-center gap-5 py-10">
        {socialLinks.map((link) => (
          <a
            key={link.name}
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 px-6 py-3 rounded-lg bg-yellow-400 text-black font-semibold hover:opacity-60 transition duration-300"
          >
            {link.svg}
            {link.name}
          </a>
        ))}
      </div>
    </div>
  );
};

export default ReviewsSection;
